import { render, staticRenderFns } from "./smartComponents.vue?vue&type=template&id=1be5e86b&scoped=true"
import script from "./smartComponents.vue?vue&type=script&lang=js"
export * from "./smartComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be5e86b",
  null
  
)

export default component.exports